/** PURE_IMPORTS_START .._.._Observable,.._.._operator_single PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { single } from '../../operator/single';
Observable.prototype.single = single;
//# sourceMappingURL=single.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/single.js
// module id = 713
// module chunks = 0